"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _assertThisInitialized = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultViewColStyles = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
var _FormGroup = _interopRequireDefault(require("@material-ui/core/FormGroup"));
var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var defaultViewColStyles = function defaultViewColStyles(theme) {
  return {
    root: {
      padding: '16px 24px 16px 24px',
      fontFamily: 'Roboto'
    },
    title: {
      marginLeft: '-7px',
      marginRight: '24px',
      fontSize: '14px',
      color: theme.palette.text.secondary,
      textAlign: 'left',
      fontWeight: 500
    },
    formGroup: {
      marginTop: '8px'
    },
    formControl: {},
    checkbox: {
      padding: '0px',
      width: '32px',
      height: '32px'
    },
    checkboxRoot: {
      '&$checked': {
        color: theme.palette.primary.main
      }
    },
    checked: {},
    label: {
      fontSize: '15px',
      marginLeft: '8px',
      color: theme.palette.text.primary
    }
  };
};
exports.defaultViewColStyles = defaultViewColStyles;
var TableViewCol = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(TableViewCol, _react$default$Compon);
  function TableViewCol() {
    var _this;
    _classCallCheck(this, TableViewCol);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(TableViewCol).apply(this, arguments));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleColChange", function (index) {
      _this.props.onColumnUpdate(index);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "generateLabel", function (label, iconLabel) {
      if (typeof label === 'object') {
        return /*#__PURE__*/_react.default.createElement("div", {
          style: {
            display: 'flex',
            gap: '0.5em'
          }
        }, label, /*#__PURE__*/_react.default.createElement("div", null, iconLabel));
      }
      return "".concat(label);
    });
    return _this;
  }
  _createClass(TableViewCol, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        columns = _this$props.columns,
        options = _this$props.options;
      var textLabels = options.textLabels.viewColumns;
      return /*#__PURE__*/_react.default.createElement(_FormControl.default, {
        component: "fieldset",
        className: classes.root,
        "aria-label": textLabels.titleAria
      }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
        variant: "caption",
        className: classes.title
      }, textLabels.title), /*#__PURE__*/_react.default.createElement(_FormGroup.default, {
        className: classes.formGroup
      }, columns.map(function (column, index) {
        return column.display !== 'excluded' && column.viewColumns !== false && /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
          key: index,
          classes: {
            root: classes.formControl,
            label: classes.label
          },
          control: /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
            className: classes.checkbox,
            classes: {
              root: classes.checkboxRoot,
              checked: classes.checked
            },
            onChange: _this2.handleColChange.bind(null, index),
            checked: column.display === 'true',
            value: column.name
          }),
          label: _this2.generateLabel(column.label, column.iconViewColumnsLabel)
        });
      })));
    }
  }]);
  return TableViewCol;
}(_react.default.Component);
_defineProperty(TableViewCol, "propTypes", {
  /** Columns used to describe table */
  columns: _propTypes.default.array.isRequired,
  /** Options used to describe table */
  options: _propTypes.default.object.isRequired,
  /** Callback to trigger View column update */
  onColumnUpdate: _propTypes.default.func,
  /** Extend the style applied to components */
  classes: _propTypes.default.object
});
var _default = (0, _styles.withStyles)(defaultViewColStyles, {
  name: 'MUIDataTableViewCol'
})(TableViewCol);
exports.default = _default;